import { styled } from "styled-components";

export const withPointerCursor = (Component) => styled(Component)`
  cursor: pointer;
`;
